module.exports = __webpack_public_path__ + "img/D201603_1.438e69ce.jpg";